import { Component, Input, Output, EventEmitter } from '@angular/core';

interface Produit {
  id: string;
  nom: string;
  code: string;
  prix: number;
  quantite: number;
  imageUrl: string;
}

@Component({
  selector: 'app-panier',
  templateUrl: 'panier.component.html',
  styleUrls: ['panier.component.css']
})
export class PanierComponent {
  @Input() articles: Produit[] = [];
  @Output() retirer = new EventEmitter<Produit>();
  @Output() miseAJour = new EventEmitter<Produit>();

  total(): number {
    return this.articles.reduce((sum, p) => sum + p.prix * p.quantite, 0);
  }

  incrementer(produit: Produit) {
    produit.quantite++;
    this.miseAJour.emit(produit);
  }

  decrementer(produit: Produit) {
    if (produit.quantite > 1) {
      produit.quantite--;
      this.miseAJour.emit(produit);
    } else {
      this.supprimer(produit);
    }
  }

  supprimer(produit: Produit) {
    this.retirer.emit(produit);
  }
}
